module.exports = __webpack_public_path__ + "static/horizon_screen-1cbf959ee4fb62179ad881ef934f4c05.png";